import {Component, OnInit} from '@angular/core';
import {GlobalService} from '../../global.service';
import {MatDialog} from '@angular/material/dialog';


@Component({
  selector: 'app-view-map',
  templateUrl: './view-map.component.html',
  styleUrls: ['./view-map.component.css']
})
export class ViewMapComponent implements OnInit {
  public latitude: number;
  public longitude: number;
  public zoom: number;

  constructor( public dialog: MatDialog, public globalService: GlobalService) {
  }

  ngOnInit() {
    if (this.globalService.pinnedLoc.value) {
      this.zoom = 12;
      this.latitude = this.globalService.pinnedLoc.value.latitude;
      this.longitude = this.globalService.pinnedLoc.value.longitude;
    }
  }

  navigate() {
    if (this.globalService.isBrwoser) {
      window.open('https://www.google.com/maps/search/?api=1&query=' + this.globalService.pinnedLoc.value.latitude
        + ',' + this.globalService.pinnedLoc.value.longitude, '_blank');
    }
  }

}
